module.exports = __webpack_public_path__ + "static/media/WATCH@3x.98840165.png";